 
      <app-search [showHide]="show" (childEvent)="filterData($event)"></app-search>
      <div class="container">
        <div class="row">
          <main class="col-md-9 ms-sm-auto col-lg px-md-4">
            <div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom"></div>
      
            <img src="./../../assets/airplane.jpg" (mouseover)="resizeImg()" [@zoominout]="zoom ? 'in' : 'out'" class="img-fluid mx-auto d-block" style="height: 300px;" alt="Airplane taking off from airport" />
            
            <div  class="table-responsive">       
              <table  class="table table-striped table-sm">
                <thead>
                  <tr *ngIf="filteredFlight">
                    <th scope="col">Country</th>
                    <th scope="col">Call Sign</th>
                    <th scope="col">Date</th>
                    <th scope="col">Time</th>
                    <th scope="col">Departure </th>
                    <th scope="col">Arrival </th>
                  </tr>
                </thead>
                            
                <tbody>
                  <tr *ngFor="let flightInfo of filteredFlight">
                    <td *ngIf="flightInfo[2]; else showDis" id="country">{{flightInfo[2]}}</td>
                    <td *ngIf="flightInfo[1]; else showDis" id="airplane-id">{{flightInfo[1]}}</td>
                    <td *ngIf="flightInfo[3]; else showDis" id="date">{{flightInfo[3] * 1000 | date}}</td>
                    <td *ngIf="flightInfo[3]; else showDis" id="time">{{flightInfo[3] * 1000 | date:'h:mm a z'}}</td>
                    <td *ngIf="flightInfo[11] > 0; else showDis" id="departure"><i class="bi bi-arrow-up-square-fill"></i></td>
                    <td *ngIf="flightInfo[11] < 0; else showDis" id="arrival"><i class="bi bi-arrow-down-square-fill"></i></td>
                    <ng-template #showDis>
                      <td id="arrival">N/A</td>
                    </ng-template>
                  </tr>
                </tbody>
              </table>
            </div>
            <div *ngIf="!filteredFlight" class="d-block ml-10">
              <div class="d-flex justify-content-center">
                <div class="spinner-border" style="width: 5rem; height: 5rem;" role="status">
                  <span class="sr-only"></span>
                </div>
              </div>
            </div>
            
          </main>
        </div>
      </div>
